export default "__VITE_ASSET__C2NnC3tx__"